/// <reference types="bun-types" />
/// <reference lib="dom" />
/// <reference lib="dom.iterable" />

import { gsap } from "gsap";
import { PixiPlugin } from "gsap/PixiPlugin.js";
import { TextPlugin } from "gsap/TextPlugin.js";
import * as PIXI from "pixi.js-legacy";
import * as elements from "./src/elements";

PIXI.settings.RESOLUTION = window.devicePixelRatio;
PIXI.settings.ROUND_PIXELS = true;

gsap.registerPlugin(PixiPlugin);
gsap.registerPlugin(TextPlugin);
PixiPlugin.registerPIXI(PIXI);

// Need to reference the elements otherwise bundling will optimise them
// out.
elements;

gsap.ticker.add((time, deltaTime, frame) => {
  const children = gsap.globalTimeline.getChildren();
  if (frame % 120 === 0) {
    if (children.length === 0) {
      gsap.ticker.sleep();
    }
  }
});

const msg = `
Hello! 👋

Thank you for taking an interest in how this post works. I had long been
fascinated by bloom filters before writing this post. I felt like they were
quite a niche data structure that few people knew about or had use for, so when
I wrote this post I wasn't expecting it to draw much attention. I was wrong, and
the response from people was very flattering.

I assume that you're here because you're interested in how the post works.  This
post has source maps, so it should be possible to browse the original TypeScript
code right here in your browser. If you would prefer to root through it on
GitHub, though, the code is open sourced at
https://github.com/samwho/visualisations.

If you have any questions or feedback, please feel free to open an issue!
`;
console.log(msg);
